module.exports = __webpack_public_path__ + "static/img/supermar.1d4ce83.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/index/story/supermar.png
// module id = +G2H
// module chunks = 1